export function getUniqueHashString(length: number = 20) {

    return "x".repeat(length).replace(/[x]/g, () => {

        // tslint:disable:no-bitwise
        const val = Math.random() * 16 | 0;
        return val.toString(16);
    });
}
